// HQ Home, for the founder and executives: who on the team has VERA Studio open now, and when the others were last seen.
// Refreshes every minute. Hidden for everyone else, and when the server doesn't offer it.
import { useEffect, useState } from "react";
import { lastSeenText, presence, type PresencePerson } from "../lib/presence";
import { useStudio } from "./ui";

export function TeamOnlineCard() {
  const { getToken } = useStudio();
  const [people, setPeople] = useState<PresencePerson[] | null>(null);
  useEffect(() => {
    let stop = false;
    const load = () => presence.list(getToken).then((p) => { if (!stop) setPeople(p); }).catch(() => { if (!stop) setPeople(null); });
    load();
    const t = window.setInterval(load, 60_000);
    return () => { stop = true; window.clearInterval(t); };
  }, [getToken]);
  if (!people) return null;
  const online = people.filter((p) => p.online);
  return (
    <section className="card">
      <div className="row between">
        <h2>Team in VERA Studio</h2>
        <span className="faint small">{online.length ? `${online.length} online now` : "Nobody online right now"}</span>
      </div>
      {!people.length ? <p className="faint">Nobody has opened VERA Studio since this started. Each teammate shows here once they do.</p> : (
        <ul className="list">
          {people.map((p) => (
            <li key={p.name} className="row between">
              <span>{p.online ? "● " : "○ "}{p.name}</span>
              <span className="faint small">{p.online ? "Online now" : `Last seen ${lastSeenText(p.lastSeen)}`}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
